import {Event as Event_V3} from '@wix/ambassador-events-v3-event/types'
import {CalendarDayV2, EVENT_FILTER_TYPE} from '@wix/wix-events-commons-statics'
import {ControllerFlowAPI} from '@wix/yoshi-flow-editor'
import {setBaseEnvironment, setFormFactor} from '../../../../commons/actions/environment'
import {RIBBON} from '../../../../commons/constants/ribbons'
import {CommonState, CommonStoreExtraArgs, DemoEvents, SiteSettings} from '../../../../commons/types/state'
import {EVENT_BADGE} from '../../../../settings-commons/components/event-badges/interfaces'
import {WidgetComponentConfig} from '../../types'
import {
  addCalendarMonth,
  closeMonthlyCalendarEvent,
  closeMonthlyCalendarPopup,
  loadCalendar,
  openMonthlyCalendarEvent,
  openMonthlyCalendarPopup,
  resetCalendar,
  subCalendarMonth,
} from '../actions/calendar-layout'
import {selectCategory} from '../actions/categories'
import {updateStyles} from '../actions/component'
import {shareEvent} from '../actions/event'
import {loadEventsPage} from '../actions/events'
import {closeListLayoutItems, openListLayoutItem, widgetLoaded} from '../actions/layout'
import {openMembersModal} from '../actions/members'
import {navigateToPage, onLinkNavigatedToPage} from '../actions/navigate-to-page'
import {updateSettings} from '../actions/sdk'
import {setVeloCategoryFilter} from '../actions/velo-overrides'
import {CategoriesState} from '../reducers/categories'
import {MembersState} from '../reducers/members'
import {MembershipOffersState} from '../reducers/membership-offers'
import {TotalGuestsState} from '../reducers/total-guests'
import {DynamicVeloOverridesState} from '../reducers/velo-overrides'
import {Api} from '../utils/api'

export interface Actions {
  loadCalendar: typeof loadCalendar
  addCalendarMonth: typeof addCalendarMonth
  resetCalendar: typeof resetCalendar
  subCalendarMonth: typeof subCalendarMonth
  navigateToPage: typeof navigateToPage
  onLinkNavigatedToPage: typeof onLinkNavigatedToPage
  updateStyles: typeof updateStyles
  updateSettings: typeof updateSettings
  setBaseEnvironment: typeof setBaseEnvironment
  closeListLayoutItems: typeof closeListLayoutItems
  openListLayoutItem: typeof openListLayoutItem
  openMonthlyCalendarPopup: typeof openMonthlyCalendarPopup
  closeMonthlyCalendarPopup: typeof closeMonthlyCalendarPopup
  openMonthlyCalendarEvent: typeof openMonthlyCalendarEvent
  closeMonthlyCalendarEvent: typeof closeMonthlyCalendarEvent
  widgetLoaded: typeof widgetLoaded
  openMembersModal: typeof openMembersModal
  shareEvent: typeof shareEvent
  setFormFactor: typeof setFormFactor
  loadEventsPage: typeof loadEventsPage
  selectCategory: typeof selectCategory
  setVeloCategoryFilter: typeof setVeloCategoryFilter
}

export interface State extends CommonState {
  events: Events
  component: WidgetComponentConfig
  demoEvents: DemoEvents
  layout: Layout
  calendarLayout: CalendarLayout
  categories: CategoriesState
  owner: boolean
  memberLoggedIn: boolean
  members: MembersState
  membershipOffers: MembershipOffersState
  totalGuests: TotalGuestsState
  dynamicVeloOverrides: DynamicVeloOverridesState
  siteSettings: SiteSettings
}

export interface Events {
  events: (ExtendedEvent | Event_V3)[]
  moreLoading: boolean
  hasMore: boolean
  filterType: EVENT_FILTER_TYPE
  latestRequestId: string
}

export interface Layout {
  listItemOpened: string
  forceShowRibbon: RIBBON
  forcedEventBadge: EVENT_BADGE
}

export enum CalendarLoading {
  DEFAULT = 1,
  PREVIOUS,
  NEXT,
}

export interface CalendarLayout {
  referenceMonth: string
  referenceDay: string
  today: string
  month: Dictionary<{
    next: string
    previous: string
    fullMonthText: string
  }>
  monthly: MonthlyCalendarLayout
  weekDayNames: string[]
  loadedPages: string[]
  loading: CalendarLoading
  events: Dictionary<string[]>
  demoEvents: Dictionary<string[]>
  days: Dictionary<CalendarDayV2>
}

export interface MonthlyCalendarLayout {
  selectedDate: string
  selectedEventId: string
}

export interface StoreExtraArgs extends CommonStoreExtraArgs {
  serverApi: Api
  flowAPI: ControllerFlowAPI
}
